import { createContext, useReducer } from "react";
import * as types from "./types";

const initialState = {
  totalAuditVsCompleteAudit: {},
  totalAuditVsCompleteAuditLoader: false,
  countLevel: {},
  gradingGraph: {},
  query: {},
  radarGraphData: {},
  level2: {},
  level3: {},
  level4: {},
  level5: {},
};

const dashboardReducer = (state, action) => {
  switch (action.type) {
    case types.TOTAL_AUDIT_VS_COMPLETE_AUDIT:
      return {
        ...state,
        totalAuditVsCompleteAudit: action.payload,
      };
    case types.TOTAL_AUDIT_VS_COMPLETE_AUDIT_LOADER:
      return {
        ...state,
        totalAuditVsCompleteAuditLoader: action.payload,
      };
    case types.COUNT_LEVEL:
      return {
        ...state,
        countLevel: action.payload,
      };
    case types.GRADING_GRAPH:
      return {
        ...state,
        gradingGraph: action.payload,
      };
    case types.SET_QUERY:
      return {
        ...state,
        query: action.payload,
      };
    case types.RADAR_GRAPH:
      return {
        ...state,
        radarGraphData: action.payload,
      };
    case types.LEVEL2:
      return {
        ...state,
        level2: action.payload,
      };
    case types.LEVEL3:
      return {
        ...state,
        level3: action.payload,
      };
    case types.LEVEL4:
      return {
        ...state,
        level4: action.payload,
      };
    case types.LEVEL5:
      return {
        ...state,
        level5: action.payload,
      };
    default:
      return state;
  }
};

export const DashboardContext = createContext(initialState);

export const DashboardProvider = ({ children }) => {
  const [dashboardState, dashboardDispatch] = useReducer(
    dashboardReducer,
    initialState
  );

  return (
    <DashboardContext.Provider value={[dashboardState, dashboardDispatch]}>
      {children}
    </DashboardContext.Provider>
  );
};

export default DashboardProvider;
